// component
import { I1000FollowerRankDB } from 'type/db';

import TableCell from 'components/common/table/cell/TableCell';
import CorePictureAvatar from 'shared/avatar/CorePictureAvatar';
import CoreSvg from 'shared/CoreSvg';
import Icon from 'shared/icons';
import CoreTag from 'shared/tag/CoreTag';
import { EllipsisText } from 'styles/styled-components/report';
import style from 'styles/styled-components/style';
// utils
import { setCategoryColor } from 'utils/colorType';
import round, { floatFixed, roundFloat } from 'utils/round';
// type
import { more_1000_follower_header_arr } from 'utils/table';

const use1000FollowerTable = () => {
	/** cell_type이 number인 cell */
	const numberCell = (value: number | null, unit: string, idx: number) => {
		const result = value === null ? '-' : `${round(value, 'round')} ${unit}`;
		return (
			<TableCell _width={more_1000_follower_header_arr[idx].width} cell_type="number">
				{result}
			</TableCell>
		);
	};

	// 리턴할 객체
	const match_cell_mapper: Record<
		string,
		(data: I1000FollowerRankDB, idx: number, row_idx: number) => JSX.Element
	> = {
		category: (data, idx) => {
			return (
				<TableCell _width={more_1000_follower_header_arr[idx].width}>
					<Grid flex="start">
						{data?.category1 && (
							<CoreTag
								tag_type="text"
								color_type={setCategoryColor(data?.category1)}
								value={data?.category1}
							/>
						)}
						{data?.category2 && (
							<CoreTag
								tag_type="text"
								color_type={setCategoryColor(data?.category2)}
								value={data?.category2}
							/>
						)}
					</Grid>
				</TableCell>
			);
		},

		id: (data, idx) => (
			<TableCell _width={more_1000_follower_header_arr[idx].width}>
				<Grid flex="start" _gap="16px" _padding="0 0 0 16px">
					<CoreSvg>
						<Icon.Insta />
					</CoreSvg>
					<CorePictureAvatar
						size={'default'}
						color_type={'blue'}
						text={data?.username}
						picture={data?.profileImage}
					/>
					<Grid flex="start" direction="column" align_items="start">
						<Grid _width="160px" flex="start" _gap="8px">
							<EllipsisText typo="p_bold">{data?.username}</EllipsisText>
						</Grid>
						<EllipsisText _width="160px" typo="span">
							{data?.biography}
						</EllipsisText>
					</Grid>
				</Grid>
			</TableCell>
		),
		follower: (data, idx) => numberCell(data?.followers, '명', idx),
	};

	return match_cell_mapper;
};

const { Grid, Text } = style;

export default use1000FollowerTable;
